module.exports = __webpack_public_path__ + "dash_20_app_assets/img/content-img-3.ca080c4c.jpg";